import {
    GetStaticProps, InferGetStaticPropsType
} from 'next';
import Head from 'next/head';

import SunnysideFooter from '../../components_sunnyside/footer';
import SunnysideHeader from '../../components_sunnyside/header';
import SunnysideMain from '../../components_sunnyside/main';
import SunnysideWrapper from '../../components_sunnyside/wrapper';
import BrightestSection from '../../sections/reusable/brightest';
import FooterFeatured from '../../sections/reusable/footer_featured';
import TermsPolicy from '../../sections/terms/terms_policy';
import {
    colors
} from '../../styles/_colors';
import prismic from '../../utils/prismic';
import {
    PrismicPaginatedResponse
} from '../../utils/prismic/types';
import {
    PrismicBasicPageResponseData
} from '../../utils/prismic/types/pages/basic.type';
import TrackingScripts from '../../sections/trackingScripts';

export const getStaticProps: GetStaticProps = async () => {
    const data: PrismicPaginatedResponse<PrismicBasicPageResponseData> = await prismic()
        .getByUid('basic_page', 'terms');
    return {
        props: {
            data,
            metaData: {
                ogTitle: 'Sunnyside',
                ogSiteName: 'Sunnyside',
                ogUrl: 'https://www.sunnyside.co/terms',
                ogDescription: '',
                ogImage: 'https://images.prismic.io/sunnysidetest/63e6349a-7e7b-4ce2-9841-54c570ebcda7_sunnyside-og.jpg?auto=compress,format',
                title: data.results[0].data.meta_title,
                disableNoIndex: true,
            }
        },
        revalidate: 30
    };
};

export default function TermsPage({
    data
}: InferGetStaticPropsType<typeof getStaticProps>): JSX.Element {
    const document = data.results[0];

    return (
        <SunnysideWrapper>
            <TrackingScripts />
            <Head>
                <meta
                    name="description"
                    content={document.data.meta_description}
                />
                <link
                    rel="canonical"
                    href="https://www.sunnyside.co/terms"
                />
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />
                <meta
                    name="twitter:title"
                    content="Sunnyside"
                />
                <meta
                    name="twitter:description"
                    content=""
                />
                <meta
                    name="twitter:image"
                    content="https://images.prismic.io/sunnysidetest/b2fc85a6-8ff8-4809-942e-7d436eb35dae_sunnyside-og.png"
                />
                <meta
                    name="twitter:site"
                    content="@joinsunnyside"
                />
                <meta
                    name="twitter:creator"
                    content="@joinsunnyside"
                />
            </Head>
            <SunnysideHeader bgcolor={colors.cloud}/>
            <SunnysideMain>
                <TermsPolicy termsPolicy={document}/>
                <BrightestSection />
                <FooterFeatured />
            </SunnysideMain>
            <SunnysideFooter />
        </SunnysideWrapper>
    );
}
